//@flow
import React from 'react';
import { decamelizeKeys } from 'humps';
import { stringify } from 'query-string';
import isBefore from 'date-fns/is_before';
import { Formik, FormikValues } from 'formik';
import { RouteComponentProps } from 'react-router-dom';
// import {
//   Col,
//   Modal,
//   Button,
//   ModalBody,
//   ModalHeader,
//   ModalFooter,
// } from 'reactstrap';
// import differenceInDays from 'date-fns/difference_in_days';

import {
  Pax,
  Location,
  TripType,
  DatePicker,
  Nationality,
  SearchButton,
} from './FormElements';
import useFlightPageContext from '../../static-db';
import { injectFlightSearchParams } from '../../Common';
// import { WhitePanel } from '../../../../components';
// import SpecialErrorMessage from './SpecialErrorMessage';

// import config from '../../../../config';

type Props = RouteComponentProps & {
  queryParams: object,
};

const COMMON = {
  tripType: 'R',
  numAdults: 1,
  numChildren: 0,
  arrivalDate: '',
  departureDate: '',
  nationality: 'US',
};

function SearchForm(props: Props) {
  // const [showMessageModel, setShowMessageModel] = React.useState(false);
  // const toggle = () => setShowMessageModel(!showMessageModel);

  const { pageTitle, subTitle, CreditMessage } = useFlightPageContext();

  function pushUrlWithValues(formData: FormikValues) {
    
    // if(isDepartureDateInvalid(formData.departureDate)) {
    //   return setShowMessageModel(true);
    // }

    const isOneWay = formData.tripType === 'O';
    if (isOneWay) delete formData.arrivalDate;

    history.push({
      search: `?${stringify(decamelizeKeys(formData))}`,
      pathname: pathname.slice(-1) === "/" ? pathname.substring(0, pathname.length -1) : pathname,
    });
  }

  const {
    history,
    location: { pathname },
    queryParams,
  } = props;

  return (
    <React.Fragment>
      {/* 
      <Modal isOpen={showMessageModel} toggle={toggle}>
        <ModalHeader toggle={toggle}>Important Notice</ModalHeader>
        <ModalBody>
          <SpecialErrorMessage />
        </ModalBody>
        <ModalFooter>
          <a
            href={`mailto:${config.honeyguideEmail}`}
            style={{ color: '#00C0FF' }}
          >
            <Button color="yellow">Email HoneyGuide</Button>
          </a>
        </ModalFooter>
      </Modal> 
      */}
      <Formik
        initialValues={createInitialValues(queryParams)}
        validate={validateForm}
        onSubmit={pushUrlWithValues}
      >
        <div className="flight-search">
          <div className="search-panel">
            <h1 className="ft-page-title">{pageTitle}</h1>
            <p className="sub">{subTitle}</p>
            <section className="SearchForm">
              <TripType />
              <div className="field-wrapper">
                <Location />
                <DatePicker />
                <Nationality />
                <Pax />
                <SearchButton />
              </div>
            </section>
            <CreditMessage />
          </div>
        </div>
      </Formik>
    </React.Fragment>
  );
}

/**
 *
 * @param   {object}  queryParams
 * @returns {object}
 * if queryparams is empty, returns INITIAL_VALUES
 * otherwise merges between the values from the queryParams and INITIAL_VALUES
 */

function createInitialValues(queryParams, pageContext) {
  const { from, to } = useFlightPageContext();
  const initialValues = { fromLocation: from, toLocation: to, ...COMMON };

  if (!queryParams && Object.keys(queryParams).length === 0) {
    return initialValues;
  }

  let merged = {};

  for (let key in initialValues) {
    if (queryParams.hasOwnProperty(key)) {
      merged = { ...merged, [key]: queryParams[key] };
    } else {
      const defaultValue = initialValues[key];
      merged = { ...merged, [key]: defaultValue };
    }
  }

  return merged;
}

function validateForm(values) {
  const { arrivalDate, departureDate, tripType } = values;
  const isRoundTrip = tripType === 'R';

  let errors = {};

  if (isRoundTrip) {
    if (!arrivalDate) errors.arrivalDate = 'Please enter your arrival date';
    if (isBefore(arrivalDate, departureDate))
      errors.arrivalDate = 'Arrival date cannot be before than departure date';
  }

  if (!departureDate) errors.departureDate = 'Please enter your departure date';

  return errors;
}

// function changeAllKtmFlightToRch(formData) {
//   let { fromLocation, toLocation, departureDate } = formData;
//   // Change KTM flights to RCH only if departureDate is defore December
//   if (isBefore(departureDate, new Date('2019', '11', '01'))) {
//     if (fromLocation === 'KTM' && toLocation === 'LUA') fromLocation = 'RCH';
//     if (toLocation === 'KTM' && fromLocation === 'LUA') toLocation = 'RCH';
//   };
    
//   return { ...formData, fromLocation, toLocation };
// }

// function isLuklaFlight(formData) {
//   const { fromLocation, toLocation } = formData;

//   return (
//     (fromLocation === 'KTM' && toLocation === 'LUA') ||
//     (fromLocation === 'LUA' && toLocation === 'KTM') ||
//     (fromLocation === 'RCH' && toLocation === 'LUA') ||
//     (fromLocation === 'LUA' && fromLocation === 'RCH'))
// }

// const isDepartureDateInvalid = departureDate => {
//   return differenceInDays(departureDate, new Date()) <= 8;
// }

export default injectFlightSearchParams(SearchForm);



// WEBPACK FOOTER //
// ./src/screens/Flights/SearchAndResults/SearchForm/SearchForm.js